import { render, staticRenderFns } from "./VisaIns.vue?vue&type=template&id=c034c7ce&scoped=true&"
import script from "./VisaIns.vue?vue&type=script&lang=js&"
export * from "./VisaIns.vue?vue&type=script&lang=js&"
import style0 from "./VisaIns.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VisaIns.vue?vue&type=style&index=1&id=c034c7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c034c7ce",
  null
  
)

export default component.exports